exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".canvas[data-v-32b53ae9]{position:fixed;top:2000px}", ""]);

// exports
